// Formats an API date (ISO UTC string or Date) in US Eastern time.
// The backend stores dates as UTC; every admin display must convert to
// America/New_York so times match the uploaded CSV values.
export function formatEastern(value, { dateOnly = false } = {}) {
  if (!value) return "N/A";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value); // not parseable — show as-is
  const opts = {
    timeZone: "America/New_York",
    month: "short",
    day: "2-digit",
    year: "numeric",
    ...(dateOnly ? {} : { hour: "2-digit", minute: "2-digit", hour12: true }),
  };
  return new Intl.DateTimeFormat("en-US", opts).format(d).replace(",", "");
}
